<app-badge badgeType="danger" *ngIf="outgoingJob.display_status == 'error' || outgoingJob.display_status == 'stalled'">
  {{ outgoingJob.display_status_str }}
  <span *ngIf="outgoingJob.status == 'sent' && !outgoingJob.everything_sent"> &nbsp;(partial) </span>
</app-badge>
<app-badge badgeType="secondary" *ngIf="outgoingJob.display_status == 'disabled'">
  {{ outgoingJob.display_status_str }}
  <span *ngIf="outgoingJob.status == 'sent' && !outgoingJob.everything_sent"> &nbsp;(partial) </span>
</app-badge>
<app-badge badgeType="success" *ngIf="outgoingJob.display_status == 'ready'">
  {{ outgoingJob.display_status_str }}
  <span *ngIf="outgoingJob.status == 'sent' && !outgoingJob.everything_sent"> &nbsp;(partial) </span>
</app-badge>
<app-badge badgeType="warning" *ngIf="outgoingJob.display_status == 'waiting'">
  {{ outgoingJob.display_status_str }}
  <span *ngIf="outgoingJob.status == 'sent' && !outgoingJob.everything_sent"> &nbsp;(partial) </span>
</app-badge>
<app-badge badgeType="primary" *ngIf="outgoingJob.status == 'sent'">
  {{ outgoingJob.display_status_str }}
  <span *ngIf="outgoingJob.status == 'sent' && !outgoingJob.everything_sent"> &nbsp;(partial) </span>
</app-badge>